import { render, staticRenderFns } from "./AddMemberCard.vue?vue&type=template&id=1b0164d2&"
import script from "./AddMemberCard.vue?vue&type=script&lang=js&"
export * from "./AddMemberCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports